import React, { useState, useEffect } from 'react';
import {
  Text,
  Select,
  TextInput,
  Modal,
  Button,
  Checkbox
} from "@mantine/core";
import { Search } from "tabler-icons-react";
import UniversalTable from "../../components/Common/UniversalTable";
import TablePagination from "../../components/Common/TablePagination";
import { fetchAgreementData } from "../../utilities/apis/recovery";
import { formatDate } from "../../utilities/utilities";


const AgreementListModal = ({ agreementData, setAgreementData, setFormState, setRegisteredNameDropDown }) => {
  const [uiConfig, setUiConfig] = useState({
    page: 1,
    pageSize: 10,
    totalCount: 116,
    apiCall: true,
    filters: {
      titleOfAgreement: null,
      typeOfAgreement: null,
      OR: [
        { secondParty: { path: "$.name", string_contains: "" } },
        {
          secondParty: {
            path: "$.indi_name",
            string_contains: "",
          },
        },
      ],
    },
    dropDown: {
      category: [
        "NDA",
        "Service Agreement",
      ],
      title: [
        "LawSigna NDA",
        "LawSigna Services",
      ]
    }
  });

  const getAgreementData = async () => {
    const { page, pageSize, filters } = uiConfig;
    const { titleOfAgreement, typeOfAgreement, OR } = filters;

    const payload = {
      page,
      pageSize,
      filters: {
        OR,
        ...(titleOfAgreement && { titleOfAgreement }),
        ...(typeOfAgreement && { typeOfAgreement }),
      },
    };

    const response = await fetchAgreementData(payload);
    if (response.status === 200) {
      setAgreementData({
        ...agreementData,
        list: response.data.agreementsList
      });
      setUiConfig({
        ...uiConfig,
        totalCount: response.data.count,
        apiCall: false,
      });
    }
  };

  useEffect(() => {
    if (uiConfig.apiCall) {
      getAgreementData();
      setUiConfig((prevState) => ({ ...prevState, apiCall: false }));
    }
  }, [uiConfig.apiCall, agreementData.isModalOpen]);

  const handleAgreementSelect = (agreement) => {
    if (agreement.secondParty.entityType) {
      setFormState((prevState) => ({
        ...prevState,
        type: "entity",
        entityType: agreement.secondParty.entityType || null,
        registeredName: agreement.secondParty.name || null,
        representativeName: agreement.secondParty.signatory || null,
        representativeEmail: agreement.secondParty.email || null,
        registeredAddress: agreement.secondParty.address || null,
        businessUnit: agreement.mapBusinessunit,
      }));
      setRegisteredNameDropDown((prevData) => [...prevData, agreement.secondParty.name]);
    } else {
      setFormState((prevState) => ({
        ...prevState,
        type: "individual",
        individualName: agreement.secondParty.indi_name || null,
        emailID: agreement.secondParty.indi_email || null,
        residenceAddress: agreement.secondParty.indi_address || null,
        phoneNo: agreement.secondParty.indi_phone || null,
      }));
    }
    setAgreementData({
      ...agreementData,
      isModalOpen: false,
      selectedAgreement: agreement.id,
    });
    console.log("Agreement Selected", agreement);
  };

  const handleClearClick = () => {
    setUiConfig({
      ...uiConfig,
      page: 1,
      apiCall: true,
      filters: {
        titleOfAgreement: null,
        typeOfAgreement: null,
        OR: [
          { secondParty: { path: "$.name", string_contains: "" } },
          {
            secondParty: {
              path: "$.indi_name",
              string_contains: "",
            },
          },
        ],
      },
    });
  }

  const agreementTableHeaders = [
    {
      label: '',
      align: 'center',
      width: '70px',
      render: (agreement) => (
        <Checkbox
          title="Select Contract"
          id={agreement.id}
          onChange={() => handleAgreementSelect(agreement)}
        />
      ),
    },
    { label: 'Reference no.', key: 'id' },
    { label: 'Title', key: 'titleOfAgreement' },
    { label: 'Type', key: 'typeOfAgreement' },
    { label: 'Location', key: 'location',width: '70px' },
    {
      label: 'Second Party',
      render: (agreement) => (
        <Text size="sm">{agreement.secondParty?.name ?? '--'}</Text>
      ),
    },
    {
      label: 'Created Date',
      render: (agreement) => (
        <Text size="sm">{formatDate(agreement.createdAt)}</Text>
      ),
    },
  ];

  return (
    <Modal
      overflow="inside"
      opened={agreementData.isModalOpen}
      onClose={() =>
        setAgreementData({ ...agreementData, isModalOpen: false })
      }
      size="calc(70vw)"
      title="Contract List"
    >
      <br />
      <div className="flex w-full justify-between items-center">
        <div className="flex flex-col">
          <div className="flex flex-row-sm">
            <div className="flex items-center">
              <TextInput
                className="mx-2 min-w-[225px]"
                placeholder="search second party"
                icon={<Search size={14} />}
                value={uiConfig.filters.OR[0].secondParty.string_contains}
                onChange={(e) =>
                  setUiConfig({
                    ...uiConfig,
                    filters: {
                      ...uiConfig.filters,
                      OR: [
                        { secondParty: { path: "$.name", string_contains: e.target.value } },
                        { secondParty: { path: "$.indi_name", string_contains: e.target.value } },
                      ],
                    },
                  })
                }
              />
              <Select
                className="mx-2 min-w-[225px]"
                placeholder="select contract type"
                data={uiConfig.dropDown.category}
                value={uiConfig.filters.typeOfAgreement}
                onChange={(value) =>
                  setUiConfig({
                    ...uiConfig,
                    filters: {
                      ...uiConfig.filters,
                      typeOfAgreement: value,
                    },
                  })
                }
              />
              <Select
                className="mx-2 min-w-[225px]"
                placeholder="select contract title"
                data={uiConfig.dropDown.title}
                value={uiConfig.filters.titleOfAgreement}
                onChange={(value) =>
                  setUiConfig({
                    ...uiConfig,
                    filters: {
                      ...uiConfig.filters,
                      titleOfAgreement: value,
                    },
                  })
                }
              />
            </div>
          </div>
        </div>
      </div>
      <br />
      <Button
        className="mx-2"
        variant="outline"
        onClick={() => setUiConfig((prevState) => ({ ...prevState, page: 1, apiCall: true }))}
      >
        Search
      </Button>
      <Button className="mx-2"  onClick={handleClearClick}>
        Clear
      </Button>
      <br />
      <br />
      <UniversalTable
        headers={agreementTableHeaders}
        data={agreementData.list}
        loading={uiConfig.apiCall}
        emptyMessage="No data found"
      />
      {uiConfig.totalCount ? (
        <TablePagination
          totalCount={uiConfig.totalCount}
          page={uiConfig.page}
          pageSize={uiConfig.pageSize}
          dataLength={agreementData.list.length}
          onPageChange={(page) =>
            setUiConfig((prevState) => ({ ...prevState, page, apiCall: true }))
          }
          onPageSizeChange={(pageSize) =>
            setUiConfig((prevState) => ({ ...prevState, page: 1, pageSize, apiCall: true }))
          }
        />
      ) : null}
    </Modal>
  );
};

export default AgreementListModal;